const DEFAULT_NETWORK_MESSAGE =
  'Network error. Please check your connection and try again.'

/**
 * Formats a Fetch Response (non-ok) into a standardized error.
 * @param {Response} response - The Fetch Response object
 * @param {object|null} body - The parsed JSON body, if available
 * @returns {{ message: string, code: number, details: * }}
 */
export function formatFetchError(response, body = null) {
  return {
    message: body?.message || `Server error (${response.status})`,
    code: response.status,
    details: body || null
  }
}

/**
 * Formats a network or runtime error (fetch threw, JSON parse failed, etc).
 * @param {Error} error
 * @returns {{ message: string, code: number, details: * }}
 */
export function formatNetworkError(error) {
  return {
    message: DEFAULT_NETWORK_MESSAGE,
    code: 0,
    details: error.message || null
  }
}

/**
 * Formats an Axios error into a standardized error.
 * @param {import('axios').AxiosError} error
 * @returns {{ message: string, code: number, details: * }}
 */
export function formatAxiosError(error) {
  if (error.response) {
    const body = error.response.data
    return {
      message: body?.message || `Server error (${error.response.status})`,
      code: error.response.status,
      details: body || null
    }
  }
  return {
    message: DEFAULT_NETWORK_MESSAGE,
    code: 0,
    details: error.message || null
  }
}

/**
 * Universal dispatcher — detects error source and delegates.
 * @param {Error|Response} error
 * @param {object|null} body - only used for Fetch response errors
 * @returns {{ message: string, code: number, details: * }}
 */
export function formatApiError(error, body = null) {
  if (error.isAxiosError) {
    return formatAxiosError(error)
  }
  if (typeof error.ok === 'boolean' && typeof error.status === 'number') {
    return formatFetchError(error, body)
  }
  return formatNetworkError(error)
}
